import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "isChecked", "mode", "id", "onChange", "onClick", "variant", "value", "field", "iserror", "background", "disabled", "testId"];
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled from "styled-components";
import * as React from 'react';
import { Checkbox as FlowBiteCheckbox } from 'flowbite-react';
import { useAuth } from '@restworld/feature-authentication';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Checkbox = function Checkbox(props) {
  var title = props.title,
      isChecked = props.isChecked,
      _props$mode = props.mode,
      mode = _props$mode === void 0 ? 'clickable' : _props$mode,
      id = props.id,
      _props$onChange = props.onChange,
      onChange = _props$onChange === void 0 ? function () {
    return null;
  } : _props$onChange,
      onClick = props.onClick,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'circle' : _props$variant,
      value = props.value,
      field = props.field,
      iserror = props.iserror,
      background = props.background,
      disabled = props.disabled,
      testId = props.testId,
      rest = _objectWithoutProperties(props, _excluded);

  var _useAuth = useAuth(),
      isAuthenticated = _useAuth.isAuthenticated;

  var checkboxEl = /*#__PURE__*/_jsx(CheckboxStyled, _objectSpread(_objectSpread({
    "data-cy": testId,
    variant: variant,
    id: id,
    checked: isChecked,
    onChange: onChange,
    onClick: onClick,
    authenticated: isAuthenticated.toString(),
    value: value,
    iserror: iserror === null || iserror === void 0 ? void 0 : iserror.toString(),
    background: background,
    disabled: disabled
  }, field), rest));

  return variant === 'chip' ? /*#__PURE__*/_jsxs(ChipDivWrapper, {
    isChecked: isChecked,
    mode: mode,
    children: [checkboxEl, title ? /*#__PURE__*/_jsx(ChippedLabelStyled, {
      isChecked: isChecked,
      children: title
    }) : null]
  }) : /*#__PURE__*/_jsxs(Wrapper, {
    disabled: disabled,
    ischecked: isChecked,
    background: background,
    htmlFor: id,
    authenticated: isAuthenticated,
    mode: mode,
    children: [checkboxEl, !!title && (typeof title === 'string' ? /*#__PURE__*/_jsx(LabelStyled, {
      children: title
    }) : title)]
  });
};
export default Checkbox;
var noPointerStyle = {
  "pointerEvents": "none",
  "cursor": "auto"
};
var pointerStyle = {
  "pointerEvents": "auto",
  "cursor": "pointer"
}; // --> styled components

var Wrapper = /*#__PURE__*/_styled.label.withConfig({
  displayName: "checkboxbasic__Wrapper",
  componentId: "sc-r6t03t-0"
})(["", " ", " ", " ", " ", ""], {
  "display": "flex",
  "alignItems": "center",
  "gap": "0.625rem",
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem",
  "fontWeight": "400",
  "--tw-text-opacity": "1",
  "color": "rgb(75 85 99 / var(--tw-text-opacity))"
}, function (_ref) {
  var mode = _ref.mode;
  return mode === 'static' ? noPointerStyle : pointerStyle;
}, function (_ref2) {
  var background = _ref2.background;
  return background === 'primary' ? {
    "borderRadius": "0.5rem",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(246 245 255 / var(--tw-bg-opacity))",
    "padding": "1rem"
  } : {};
}, function (_ref3) {
  var ischecked = _ref3.ischecked,
      background = _ref3.background;
  return background && ischecked ? {
    "borderWidth": "1px",
    "--tw-border-opacity": "1",
    "borderColor": "rgb(105 62 181 / var(--tw-border-opacity))",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(226 216 243 / var(--tw-bg-opacity))"
  } : {};
}, function (_ref4) {
  var disabled = _ref4.disabled;
  return disabled ? {
    "pointerEvents": "none",
    "cursor": "not-allowed",
    "opacity": "0.6",
    "--tw-saturate": "saturate(.25)",
    "filter": "var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)"
  } : {
    "pointerEvents": "auto",
    "cursor": "pointer"
  };
});

var CheckboxStyled = /*#__PURE__*/_styled(FlowBiteCheckbox).withConfig({
  displayName: "checkboxbasic__CheckboxStyled",
  componentId: "sc-r6t03t-1"
})(["", " ", ";", ""], {
  "--tw-border-opacity": "1",
  "borderColor": "rgb(212 193 245 / var(--tw-border-opacity))",
  "padding": "0.5rem",
  ":focus": {
    "--tw-ring-opacity": "1",
    "--tw-ring-color": "rgb(105 62 181 / var(--tw-ring-opacity))"
  }
}, function (_ref5) {
  var variant = _ref5.variant,
      authenticated = _ref5.authenticated;
  return {
    circle: [{
      "display": "inline-block",
      "borderRadius": "1.5rem !important",
      "backgroundSize": "contain",
      "padding": "0px",
      ":checked": {
        "--tw-bg-opacity": "1 !important",
        "backgroundColor": "rgb(105 62 181 / var(--tw-bg-opacity)) !important"
      }
    }, authenticated === 'true' ? {
      "backgroundImage": "url('https://worker.restworld.it/utils-assets/checkbox-uncheck-cross.svg')"
    } : {
      "backgroundImage": "url('https://worker.restworld.it/utils-assets/checkbox-uncheck-minus.svg')"
    }],
    box: {
      "borderRadius": "0.25rem",
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
      ":checked": {
        "--tw-bg-opacity": "1 !important",
        "backgroundColor": "rgb(105 62 181 / var(--tw-bg-opacity)) !important"
      }
    },
    chip: [{
      ":focus": {
        "--tw-ring-opacity": "1",
        "--tw-ring-color": "rgb(105 62 181 / var(--tw-ring-opacity))"
      }
    }, {
      "display": "inline-block",
      "borderRadius": "1.5rem !important",
      "padding": "0px"
    }, {
      "height": "20px",
      "width": "20px",
      "backgroundImage": "url('https://worker.restworld.it/utils-assets/checkbox-uncheck-minus.svg')",
      "backgroundRepeat": "no-repeat",
      ":checked": {
        "--tw-bg-opacity": "1",
        "backgroundColor": "rgb(105 62 181 / var(--tw-bg-opacity))",
        "backgroundImage": "url('https://worker.restworld.it/utils-assets/check-circle.svg')"
      }
    }]
  }[variant];
}, function (_ref6) {
  var iserror = _ref6.iserror;
  return iserror === 'true' ? {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(204 0 34 / var(--tw-border-opacity))"
  } : {};
});

var LabelStyled = /*#__PURE__*/_styled.span.withConfig({
  displayName: "checkboxbasic__LabelStyled",
  componentId: "sc-r6t03t-2"
})(["", ""], {
  "cursor": "pointer",
  "fontSize": "1rem",
  "lineHeight": "1.5rem",
  "fontWeight": "400",
  "--tw-text-opacity": "1",
  "color": "rgb(75 85 99 / var(--tw-text-opacity))"
});

var ChippedLabelStyled = /*#__PURE__*/_styled.span.withConfig({
  displayName: "checkboxbasic__ChippedLabelStyled",
  componentId: "sc-r6t03t-3"
})(["", " ", ""], {
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem",
  "fontWeight": "400"
}, function (_ref7) {
  var isChecked = _ref7.isChecked;
  return isChecked ? {
    "--tw-text-opacity": "1",
    "color": "rgb(255 255 255 / var(--tw-text-opacity))"
  } : {
    "--tw-text-opacity": "1",
    "color": "rgb(73 41 131 / var(--tw-text-opacity))"
  };
});

var ChipDivWrapper = /*#__PURE__*/_styled.label.withConfig({
  displayName: "checkboxbasic__ChipDivWrapper",
  componentId: "sc-r6t03t-4"
})(["", " ", " ", ""], {
  "display": "flex",
  "height": "3rem",
  "width": "fit-content",
  "alignItems": "center",
  "gap": "1rem",
  "borderRadius": "0.375rem",
  "paddingLeft": "1rem",
  "paddingRight": "1rem",
  "paddingTop": "0.75rem",
  "paddingBottom": "0.75rem"
}, function (_ref8) {
  var isChecked = _ref8.isChecked;
  return isChecked ? {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(105 62 181 / var(--tw-bg-opacity))"
  } : {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))"
  };
}, function (_ref9) {
  var mode = _ref9.mode;
  return mode === 'static' ? noPointerStyle : pointerStyle;
});